(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("map-transparency-stack", [], factory);
	else if(typeof exports === 'object')
		exports["map-transparency-stack"] = factory();
	else
		root["map-transparency-stack"] = factory();
})(self, function() {
return 